// Week 33 Daily Watch Videos
export default {
  videos: [
    { id: "v1", title: "School Corridor Safety Rules for Kids", url: "https://www.youtube.com/embed/sample1" },
    { id: "v2", title: "First Aid Basics for Children", url: "https://www.youtube.com/embed/sample2" },
    { id: "v3", title: "Understanding Friction on Wet Surfaces", url: "https://www.youtube.com/embed/sample3" },
    { id: "v4", title: "School Safety Rules Around the World", url: "https://www.youtube.com/embed/sample4" },
    { id: "v5", title: "How to Help an Injured Classmate", url: "https://www.youtube.com/embed/sample5" }
  ]
};
